export default __webpack_public_path__ + "static/media/download_fiche_persona.650ae4b0.pdf";